import { render, staticRenderFns } from "./chlorid-ionen.vue?vue&type=template&id=bdec3b98&"
import script from "./chlorid-ionen.vue?vue&type=script&lang=js&"
export * from "./chlorid-ionen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports